import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listConfig, updateConfig } from "@/api/configurationlist";
import { progressControl } from "@/api/particulars";
import { cloneDeep } from "lodash";
import modbus from "./dialog/modbus.vue";
import ss from "./dialog/ss.vue";
export default {
  name: "",
  props: ['deviceDid', 'deviceSn'],
  data: function data() {
    return {
      tableList: [],
      dialogVisible: false,
      dialogTitle: '新增',
      tableLoading: false,
      formLoadng: false,
      currentIndex: undefined,
      functionCode: {
        '1': '1（读线圈）',
        '2': '2（读输入状态）',
        '3': '3（读保持寄存器）',
        '4': '4（读输入寄存器)'
      },
      dataTypeList: ['int16', 'uint16', 'int32', 'uint32', 'int64', 'uint64', 'float', 'double', 'bool', 'string', 'raw'],
      customTableList: [],
      s7Data: []
    };
  },
  methods: {
    getData: function () {
      var _getData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, res2, res3;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.tableLoading = true;
                _context.prev = 1;
                _context.next = 4;
                return listConfig(this.deviceSn, this.deviceDid, [{
                  config: 'modbus',
                  section: 'daqcmd',
                  options: [{
                    option: "name"
                  }, {
                    option: 'dev_addr'
                  }, {
                    option: 'interval'
                  }, {
                    option: 'slaveid'
                  }, {
                    option: 'function'
                  }, {
                    option: 'start'
                  }, {
                    option: 'datatype'
                  }, {
                    option: 'size'
                  }, {
                    option: 'endian'
                  }, {
                    option: 'factor'
                  }, {
                    option: 'bind_dev'
                  }, {
                    option: 'only_write'
                  }, {
                    option: 'buff_cmd'
                  }]
                }]);

              case 4:
                res = _context.sent;

                if (!(res.data.data.mess === '')) {
                  _context.next = 8;
                  break;
                }

                this.tableLoading = false;
                return _context.abrupt("return");

              case 8:
                this.tableList = res.data.data.mess[0].s_objects.map(function (item) {
                  return _objectSpread({
                    index: item.index,
                    sname: item.sname
                  }, item.options);
                });
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                this.$message.error('操作失败');
                this.tableLoading = false;
                return _context.abrupt("return");

              case 16:
                _context.prev = 16;
                _context.next = 19;
                return listConfig(this.deviceSn, this.deviceDid, [{
                  config: 'modbus',
                  section: 'cmd',
                  options: [{
                    option: "name"
                  }, {
                    option: "interval"
                  }, {
                    option: "type"
                  }, {
                    option: "cmd"
                  }, {
                    option: "return_flag"
                  }]
                }]);

              case 19:
                res2 = _context.sent;
                this.customTableList = res2.data.data.mess[0].s_objects.map(function (item) {
                  return _objectSpread(_objectSpread({}, item.options), {}, {
                    index: item.index,
                    sname: item.sname,
                    return_flag: item.options.return_flag == 1
                  });
                });
                _context.next = 28;
                break;

              case 23:
                _context.prev = 23;
                _context.t1 = _context["catch"](16);
                this.$message.error('操作失败');
                this.tableLoading = false;
                return _context.abrupt("return");

              case 28:
                _context.prev = 28;
                _context.next = 31;
                return listConfig(this.deviceSn, this.deviceDid, [{
                  "section": "s7cmd",
                  "config": "modbus",
                  options: [{
                    option: "name"
                  }, {
                    option: 'dev_addr'
                  }, {
                    option: 'start'
                  }, {
                    option: 'datatype'
                  }, {
                    option: 'size'
                  }, {
                    option: 'endian'
                  }, {
                    option: 'factor'
                  }, {
                    option: 'bind_dev'
                  }, {
                    option: 'rack'
                  }, {
                    option: 'slot'
                  }, {
                    option: 'area'
                  }, {
                    option: 'dbnum'
                  }]
                }]);

              case 31:
                res3 = _context.sent;
                this.s7Data = res3.data.data.mess[0].s_objects.map(function (item) {
                  return _objectSpread(_objectSpread({
                    index: item.index,
                    sname: item.sname
                  }, item.options), {}, {
                    bind_dev: item.options.bind_dev == '1'
                  });
                });
                _context.next = 40;
                break;

              case 35:
                _context.prev = 35;
                _context.t2 = _context["catch"](28);
                this.$message.error('操作失败');
                this.tableLoading = false;
                return _context.abrupt("return");

              case 40:
                this.tableLoading = false;

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 11], [16, 23], [28, 35]]);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    handleEdit: function handleEdit(row) {
      this.$refs.modbusdialog.dialogVisible = true;
      this.$refs.modbusdialog.currentData = row;
    },
    handleEditS7: function handleEditS7(row) {
      this.$refs.s7dialog.dialogVisible = true;
      this.$refs.s7dialog.currentData = row;
    },
    handleDelete: function handleDelete(row, section) {
      var _this = this;

      this.$confirm('此操作将删除该配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.tableLoading = true;
                _context2.next = 3;
                return updateConfig(_this.deviceSn, _this.deviceDid, [{
                  config: 'modbus',
                  section: section,
                  action: 2,
                  index: [row.index]
                }]);

              case 3:
                res = _context2.sent;

                if (res.data.data.mess == 0) {
                  _this.$message.success('操作成功');
                } else {
                  _this.$message.error('操作失败');
                }

                _this.getData();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    handleClose: function handleClose() {
      this.currentData = {
        name: '',
        dev_addr: 'COM1',
        interval: '5',
        slaveid: '',
        function: 1,
        start: '',
        datatype: '',
        size: '',
        precise: '3'
      };
      this.currentIndex = undefined;
    },
    addCollection: function addCollection() {
      this.$refs.modbusdialog.dialogVisible = true;
    },
    addS7Data: function addS7Data() {
      this.$refs.s7dialog.dialogVisible = true;
    },
    confirmAdd: function confirmAdd() {
      var _this2 = this;

      this.formLoadng = true;
      this.$refs.form.validate( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
          var res;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!valid) {
                    _context3.next = 10;
                    break;
                  }

                  _context3.next = 3;
                  return updateConfig(_this2.deviceSn, _this2.deviceDid, [{
                    config: 'modbus',
                    section: 'daqcmd',
                    action: _this2.currentData.sname == undefined ? 1 : 0,
                    index: _this2.currentData.sname == undefined ? [_this2.tableList.length] : [_this2.currentData.index],
                    sname: _this2.currentData.sname == undefined ? _this2.currentData.name : undefined,
                    options: _objectSpread(_objectSpread({}, _this2.currentData), {}, {
                      index: undefined,
                      sname: undefined
                    })
                  }]);

                case 3:
                  res = _context3.sent;

                  if (res.data.data.mess == 0) {
                    _this2.$message.success(_this2.dialogTitle + '成功');
                  } else {
                    _this2.$message.error(_this2.dialogTitle + '失败');
                  }

                  _this2.formLoadng = false;
                  _this2.dialogVisible = false;

                  _this2.getData();

                  _context3.next = 12;
                  break;

                case 10:
                  _this2.$message.error('请填写完整');

                  _this2.formLoadng = false;

                case 12:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    saveTap: function () {
      var _saveTap = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var data, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.tableLoading = true;
                data = [];
                this.customTableList.forEach(function (item, index) {
                  data.push({
                    config: 'modbus',
                    section: 'cmd',
                    action: item.sname == undefined ? 1 : 0,
                    index: item.sname == undefined ? [index] : [item.index],
                    sname: item.sname == undefined ? item.name : undefined,
                    options: _objectSpread(_objectSpread({}, item), {}, {
                      index: undefined,
                      sname: undefined,
                      return_flag: item.return_flag ? 1 : 0
                    }),
                    server: 'smartlink'
                  });
                });
                _context4.next = 5;
                return updateConfig(this.deviceSn, this.deviceDid, data);

              case 5:
                res = _context4.sent;

                if (res.data.data.mess == 0) {
                  this.$message.success('操作成功');
                } else {
                  this.$message.error('操作失败');
                }

                this.tableLoading = false;

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function saveTap() {
        return _saveTap.apply(this, arguments);
      }

      return saveTap;
    }(),
    deleteRow: function deleteRow(row, index) {
      var _this3 = this;

      this.$confirm('此操作将删除该配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this3.tableLoading = true;

                if (!(row.index === undefined)) {
                  _context5.next = 5;
                  break;
                }

                _this3.customTableList.splice(index, 1);

                _this3.tableLoading = false;
                return _context5.abrupt("return");

              case 5:
                _context5.next = 7;
                return updateConfig(_this3.deviceSn, _this3.deviceDid, [{
                  config: 'modbus',
                  section: 'cmd',
                  action: 2,
                  index: [row.index]
                }]);

              case 7:
                res = _context5.sent;

                if (res.data.data.mess == 0) {
                  _this3.$message.success('操作成功');
                } else {
                  _this3.$message.error('操作失败');
                }

                _this3.getData();

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })));
    },
    addRow: function addRow() {
      this.customTableList.push({
        name: '',
        interval: '',
        type: 'HEX',
        cmd: '',
        return_flag: false
      });
    },
    updateModbus: function () {
      var _updateModbus = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(d) {
        var resp;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return updateConfig(this.deviceSn, this.deviceDid, [{
                  config: 'modbus',
                  section: 'daqcmd',
                  action: d.sname === undefined ? 1 : 0,
                  index: d.sname === undefined ? [this.tableList.length] : [d.index],
                  sname: d.sname == undefined ? d.name : undefined,
                  server: 'smartlink',
                  options: _objectSpread(_objectSpread({}, d), {}, {
                    index: undefined,
                    sname: undefined,
                    bind_dev: d.bind_dev ? '1' : '0',
                    only_write: d.only_write ? '1' : '0',
                    buff_cmd: d.buff_cmd ? '1' : '0'
                  })
                }]);

              case 3:
                resp = _context6.sent;

                if (resp.data.data.mess == 0) {
                  this.$message.success('操作成功');
                  this.$refs.modbusdialog.dialogVisible = false;
                  this.$refs.modbusdialog.currentData = {
                    name: '',
                    dev_addr: '',
                    interval: '5',
                    slaveid: '',
                    function: '1',
                    start: '',
                    datatype: '',
                    size: '',
                    precise: '',
                    factor: '',
                    sname: undefined,
                    index: undefined,
                    bind_dev: false,
                    endian: 'ABCD',
                    only_write: false,
                    buff_cmd: false
                  };
                } else {
                  this.$message.error('操作失败');
                }

                _context6.next = 10;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                this.$message.error('操作失败');

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function updateModbus(_x2) {
        return _updateModbus.apply(this, arguments);
      }

      return updateModbus;
    }(),
    updateS7: function () {
      var _updateS = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(d) {
        var resp;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return updateConfig(this.deviceSn, this.deviceDid, [{
                  config: 'modbus',
                  section: 's7cmd',
                  action: d.sname === undefined ? 1 : 0,
                  index: d.sname == undefined ? [this.s7Data.length] : [d.index],
                  sname: d.sname == undefined ? d.name : undefined,
                  options: _objectSpread(_objectSpread({}, d), {}, {
                    index: undefined,
                    sname: undefined,
                    bind_dev: d.bind_dev ? '1' : '0'
                  })
                }]);

              case 3:
                resp = _context7.sent;

                if (resp.data.data.mess == 0) {
                  this.$message.success('操作成功');
                  this.$refs.s7dialog.dialogVisible = false;
                  this.$refs.s7dialog.currentData = {
                    name: '',
                    dev_addr: '',
                    start: '',
                    datatype: 'bool',
                    size: '',
                    precise: '',
                    factor: '',
                    sname: undefined,
                    index: undefined,
                    bind_dev: false,
                    endian: 'ABCD',
                    rack: '0',
                    area: 'DB',
                    dbnum: '0',
                    slot: '0'
                  };
                } else {
                  this.$message.error('操作失败');
                }

                _context7.next = 10;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                this.$message.error('操作失败');

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 7]]);
      }));

      function updateS7(_x3) {
        return _updateS.apply(this, arguments);
      }

      return updateS7;
    }()
  },
  created: function created() {
    this.getData();
  },
  components: {
    modbus: modbus,
    ss: ss
  }
};